import React from 'react';
import clsx from 'clsx';
import { ReactComponent as ArrowIcon } from 'images/arrow-rounded.svg';
import { ReactComponent as CheckIcon } from 'images/check-icon-full-green.svg';

import styles from './CardSequenceWithIcons.module.scss';

export enum CardSequenceRightIcon {
  Arrow = 'arrow',
  Checked = 'checked',
}

interface StepProps {
  icon: JSX.Element;
  title?: string;
  description?: string | JSX.Element;
  rightIcon?: CardSequenceRightIcon;
  withBorder?: boolean;
}

const CardSequenceWithIcons = ({ title, icon, description, rightIcon, withBorder = true }: StepProps) => (
  <div className={clsx(styles.cardContainer, withBorder && styles.withBorder)}>
    <div className={styles.iconContainer}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.textContainer}>
        {title && <div className={styles.title}>{title}</div>}
        {description && <div className={styles.description}>{description}</div>}
      </div>
    </div>
    {rightIcon && (
      <div className={styles.rightIcon}>
        {rightIcon === CardSequenceRightIcon.Arrow ? <ArrowIcon /> : <CheckIcon />}
      </div>
    )}
  </div>
);

export default CardSequenceWithIcons;
